import React from "react";
import { ActivityCalendar, Button, Divider, FormFieldSet, Modal, useFormHandler } from "../../../../../../components";

const ActivitiesModal = ({ open, onClose }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Frequencystartdate: "",
    FrequencyEndDate:"",
  });

  return (
    <div>
      <Modal isOpen={open}
        onClose={onClose}
        title="ACTIVITIES"
        width="max-w-5xl">
        <div >
          <ActivityCalendar/>
        </div>
      </Modal>
    </div>
  );
  
};

export default ActivitiesModal;
